module.exports = __webpack_public_path__ + "static/media/riz.62f94570.svg";